/* HOTHANNI Gratis-Geschenk-Stufen (Codext 2026-10-19)
   Legt das passende Geschenk automatisch in den Warenkorb, sobald der Bestellwert (ohne Geschenke) die Stufe erreicht,
   und nimmt es wieder raus, wenn der Wert darunter fällt. Rabatt (100 %) kommt aus den automatischen Shopify-Rabatten.
   Konfiguration: snippets/hh-gift-config.liquid (window.hhGift). */
(() => {
  const C = window.hhGift;
  if (!C || !Array.isArray(C.tiers)) return;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const KEY = 'hh-gift-declined';
  const tierIds = C.tiers.map((t) => new Set(t.variants.map((v) => v.id)));
  const allIds = new Set(C.tiers.flatMap((t) => t.variants.map((v) => v.id)));
  const load = () => { try { return JSON.parse(sessionStorage.getItem(KEY) || '{}'); } catch (e) { return {}; } };
  const save = (d) => { try { sessionStorage.setItem(KEY, JSON.stringify(d)); } catch (e) {} document.documentElement.classList.toggle('hh-gift-declined', Object.keys(d).length > 0); };
  let declined = load();
  document.documentElement.classList.toggle('hh-gift-declined', Object.keys(declined).length > 0);
  const PKEY = 'hh-gift-had';
  const loadHad = () => { try { return JSON.parse(sessionStorage.getItem(PKEY) || '{}'); } catch (e) { return {}; } };
  let had = loadHad();
  let busy = false;
  let queued = false;

  const qualTotal = (cart) => cart.items.filter((i) => !allIds.has(i.variant_id)).reduce((s, i) => s + i.final_line_price, 0);
  const isAuto = (i) => i.properties && i.properties._hh_gift;
  const post = async (url, body) => (await fetch(root + url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })).json();
  const hasDrawer = () => !!document.getElementById('cart-drawer');

  const publish = async () => {
    const sections = hasDrawer() ? ['cart-drawer'] : [];
    const cart = await post('cart/update.js', { updates: {}, sections });
    remember(cart);
    if (document.body.classList.contains('template-cart') || location.pathname.replace(root, '/').startsWith('/cart')) { location.reload(); return; }
    if (hasDrawer() && cart.sections && cart.sections['cart-drawer']) {
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'hh-gift', cart } }));
    } else {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }
  };

  const remember = (cart) => {
    had = {};
    C.tiers.forEach((t, n) => { if (cart.items.some((i) => tierIds[n].has(i.variant_id))) had[t.key] = 1; });
    try { sessionStorage.setItem(PKEY, JSON.stringify(had)); } catch (e) {}
  };

  const plan = (cart) => {
    const total = qualTotal(cart);
    const updates = {};
    const adds = [];
    C.tiers.forEach((t, n) => {
      const lines = cart.items.filter((i) => tierIds[n].has(i.variant_id));
      const reached = total >= t.threshold;
      if (!reached) {
        delete declined[t.key];
        lines.filter(isAuto).forEach((l) => { updates[l.key] = 0; });
        return;
      }
      if (had[t.key] && !lines.length) declined[t.key] = 1; /* Kunde hat es selbst entfernt */
      if (lines.length) {
        lines.filter(isAuto).forEach((l) => { if (l.quantity > 1) updates[l.key] = 1; });
        return;
      }
      if (declined[t.key]) return;
      const v = t.variants.find((x) => x.available);
      if (v) adds.push({ id: v.id, quantity: 1, properties: { _hh_gift: t.key } });
    });
    save(declined);
    return { updates, adds };
  };

  const run = async (cart) => {
    if (busy) { queued = true; return; }
    busy = true;
    try {
      if (!cart || !cart.items) cart = await (await fetch(root + 'cart.js', { credentials: 'same-origin' })).json();
      const { updates, adds } = plan(cart);
      let changed = false;
      if (Object.keys(updates).length) { await post('cart/update.js', { updates }); changed = true; }
      if (adds.length) { await post('cart/add.js', { items: adds }); changed = true; }
      if (changed) await publish(); else remember(cart);
    } catch (e) { /* Geschenk ist Bonus – Fehler nie an Kunden durchreichen */ }
    busy = false;
    if (queued) { queued = false; run(null); }
  };

  document.addEventListener('cart:change', (e) => {
    const d = e.detail || {};
    if (d.baseEvent === 'hh-gift') return;
    run(d.cart && d.cart.items ? d.cart : null);
  });

  /* Farbe tauschen / wieder hinzufügen (Buttons im Warenkorb-Balken) */
  document.addEventListener('click', async (e) => {
    const swap = e.target.closest('[data-hh-gift-swap]');
    const readd = e.target.closest('[data-hh-gift-readd]');
    if (!swap && !readd) return;
    e.preventDefault();
    if (readd) { declined = {}; save(declined); had = {}; try { sessionStorage.removeItem(PKEY); } catch (err) {} run(null); return; }
    const n = C.tiers.findIndex((t) => t.variants.some((v) => v.handle === swap.dataset.hhGiftSwap));
    if (n < 0) return;
    const v = C.tiers[n].variants.find((x) => x.handle === swap.dataset.hhGiftSwap);
    if (!v || !v.available) return;
    busy = true;
    try {
      const cart = await (await fetch(root + 'cart.js', { credentials: 'same-origin' })).json();
      const updates = {};
      cart.items.filter((i) => tierIds[n].has(i.variant_id)).forEach((l) => { updates[l.key] = 0; });
      if (Object.keys(updates).length) await post('cart/update.js', { updates });
      await post('cart/add.js', { items: [{ id: v.id, quantity: 1, properties: { _hh_gift: C.tiers[n].key } }] });
      delete declined[C.tiers[n].key]; save(declined);
      busy = false;
      await publish();
    } catch (err) { busy = false; }
  });

  if (C.cartCount > 0 || Object.keys(had).length) run(null);
})();
